<script>
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    export let value = '';
    const dispatch = createEventDispatcher();
    export let onchange;
    const select = num => () => {
        if (!value || value == "undefined" || value == "null") {
            value = "";
        }
        value += num; 
        console.log("Value : ", value, num);
        onchange();
    };
    const clear = num => () => value += '.';
    const backspace = () => value = value.slice(0, -1);
    const submit = () => dispatch('submit');
    onMount(async () => {
        if(!value || value=="undefined" || value=="null"){
            value="";
        }
    })  
</script>

<div class="keypad">
    <button on:click={select('1')}>1</button>
    <button on:click={select('2')}>2</button>
    <button on:click={select('3')}>3</button>
    <button on:click={select('4')}>4</button>
    <button on:click={select('5')}>5</button>
    <button on:click={select('6')}>6</button>
    <button on:click={select('7')}>7</button>
    <button on:click={select('8')}>8</button>
    <button on:click={select('9')}>9</button>
    <button disabled={!value} on:click={clear()}>.</button>
    <button on:click={select('0')}>0</button>
    <button disabled={!value} on:click={backspace}>Clear</button>
</div>

